import * as React from 'react';

export interface IActionCardProps {
    className?: string;
    href?: string;
    target?: string;
    description?: string;
    heading: string;
    showIcon?: boolean;
    iconClassName?: string;
    onClick?(): void;
    onKeyUp?(): void;
}

class ActionCard extends React.PureComponent<IActionCardProps> {

    public render(): JSX.Element {
        const { className, href, target, heading, description, iconClassName, showIcon } = this.props;
        const actionCardClassName = className ? `${className} ${'mfrm-action-card'}` : 'mfrm-action-card';
        const actionCardDefaultClassName = 'mfrm-action-card';

        return (
            <a
                href={href}
                target={target}
                tabIndex={0}
                className={actionCardClassName}
            >
                <div className='sr-only'>{`${heading}, ${description}`}</div>
                <div className={`${actionCardDefaultClassName}__wrapper`} tabIndex={-1} aria-hidden='true'>
                    {showIcon && <i className={`${actionCardDefaultClassName}__icon ${iconClassName ? iconClassName : ''}`} tabIndex={-1} aria-label='icon'/>}
                    <span className={`${actionCardDefaultClassName}__heading`}>{heading}</span>
                    <p className={`${actionCardDefaultClassName}__description`}>{description}</p>
                    <i className={`${actionCardDefaultClassName}__icon-chevron`} tabIndex={-1} aria-label='icon chevron'/>
                </div>
            </a>
        );
    }
}

export default ActionCard;
